import { fieldKeyToColumn } from '../../utils/buildOrderDataRows';

/**
 * Translates camelCase order field keys (e.g. `bulkFieldName` / `historyFields`
 * values) to the lowercase `cms.history.colname` values the history endpoint
 * filters on. Unknown keys are dropped rather than guessed.
 */
export function resolveHistoryFields(fieldKeys: string[]): string[] {
  return fieldKeys
    .map(fieldKeyToColumn)
    .filter((column): column is string => column !== undefined);
}
